/**
 * LocalStack presigned URLs use http://localhost:4566. That works on the dev machine only.
 * In dev, rewrite to a same-origin path so Vite can proxy to LocalStack (tunnel / LAN friendly).
 */
export const LOCAL_S3_PROXY_PREFIX = '/local-s3';

export function rewriteLocalPresignedS3Url(uploadUrl: string): string {
  if (!import.meta.env.DEV) {
    return uploadUrl;
  }
  try {
    const url = new URL(uploadUrl);
    const isLocalS3 =
      (url.hostname === 'localhost' || url.hostname === '127.0.0.1') && url.port === '4566';
    if (!isLocalS3) {
      return uploadUrl;
    }
    return `${LOCAL_S3_PROXY_PREFIX}${url.pathname}${url.search}`;
  } catch {
    return uploadUrl;
  }
}
